import React from 'react';

const escapeRegExp = (value) => String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Wrap every occurrence of `term` inside `text` so the matched part of a result
 * stands out. Falls back to plain text when there is nothing to mark.
 */
const Highlight = ({ text, term }) => {
    const source = String(text ?? '');
    const needle = String(term ?? '').trim();

    if (!needle || !source) {
        return <>{source}</>;
    }

    const parts = source.split(new RegExp(`(${escapeRegExp(needle)})`, 'ig'));

    return (
        <>
            {parts.map((part, index) => (
                part.toLowerCase() === needle.toLowerCase()
                    ? <b key={index} className="ck-gs-hit">{part}</b>
                    : <React.Fragment key={index}>{part}</React.Fragment>
            ))}
        </>
    );
};

export default Highlight;
